import { Box, Tooltip, Typography } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import I18nKey from "translations/I18nKey";
import ExclamationBlueIcon from "assets/Icons/ExclamationBlueIcon.svg";
import SellerFilter from "components/SellerFilter";
import Toggle from "components/Toggle";
import { changeSource } from "store/catalogTracker/catalogTracker.slice";
import { useDispatch } from "react-redux";

export const CatalogTrackerSourceOfTruth = {
  USER_DATA: "user_data",
  CATALOG_DATA: "catalog_data",
  LISTING_DATA: "listing_data",
};

const CatalogTrackerHeader = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [active, setActive] = useState<number>(2);
  useEffect(() => {
    if (active === 2) {
      dispatch(changeSource(CatalogTrackerSourceOfTruth.USER_DATA));
    } else if (active === 1) {
      dispatch(changeSource(CatalogTrackerSourceOfTruth.CATALOG_DATA));
    } else if (active === 3) {
      dispatch(changeSource(CatalogTrackerSourceOfTruth.LISTING_DATA));
    }
  }, [active]);

  const handleToggle = (id: number) => {
    setActive(id);
  };

  return (
    <Box
      sx={{
        marginTop: "20px",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 400,
            color: "#424242",
            fontFamily: "Lato",
          }}
        >
          {intl.formatMessage({
            id: I18nKey.CATALOG,
          })}{" "}
          :
        </Typography>
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: 600,
            color: "#424242",
            fontFamily: "Lato",
          }}
        >
          {intl.formatMessage({
            id: I18nKey.CATALOG_TRACKER,
          })}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", marginTop: "15px", position:'relative' }}>
        <Typography sx={{position:'absolute', top:'-25px'}}>Select Source of Truth</Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Toggle
            handleToggle={handleToggle}
            active={active}
            element1="User Catalog"
            element2="Seller Central"
            element3="Amazon.com"
          />
          <Box sx={{ margin: "0 12px" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ display: "flex" }}>
                <SellerFilter placeholder={"Search Summary View"} />
                <Box
                  sx={{
                    padding: "12px",
                    borderRadius: "8px",
                    border: "1px solid #D0D5DD",
                    cursor: "pointer",
                    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                    background: "white",
                    display: "grid",
                    justifyItems: "center",
                    alignItems: "center",
                  }}
                >
                  <Tooltip title="The catalog tracker provides for the comparison of ASIN level data between your own data, data added to Seller Central and the data available on Amazon itself.">
                    <img src={ExclamationBlueIcon} alt={"exclamation blue"} />
                  </Tooltip>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CatalogTrackerHeader;
